module.exports = __webpack_public_path__ + "img/sound-horizons.2f299114.png";